import { Tutorial } from './tutorial'
import { TutorialRole } from './tutorial-role'

export const entities = [Tutorial, TutorialRole]
export { Tutorial, TutorialRole }
